import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lightSceneDeviceEndState'
})
export class LightSceneDeviceEndStatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/pipes/light-scene-device-end-state.pipe.ts